module.exports = __webpack_public_path__ + "01c99f82026306ea6f7d8da04f55f24a.png";